import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { Spinner } from "react-bootstrap";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import _ from "lodash";
import { formatDate } from "../../utils/helpers.js";
import TimePicker from "react-time-picker";
import DatePicker from "react-datepicker";
import { FaClock, FaRegCalendarAlt } from "react-icons/fa";

// const formatDate = (date) => moment(date).format("YYYY-MM-DD");

const MonthlyCalendar = ({ data, setStartDate, setEndDate }) => {
  const [month, setMonth] = useState(moment().startOf("month"));
  const [time, setTime] = useState("10:00");
  const [showTimePicker, setShowTimePicker] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showDatePicker, setShowDatePicker] = useState(false);

  // Month names and days
  const MonthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const DaysName = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  // Calculate the days of the current month
  const days = useMemo(() => {
    const currentMonth = moment(month).month();
    const currentYear = moment(month).year();

    let firstDay = new Date(currentYear, currentMonth, 1).getDay();
    firstDay = firstDay === 0 ? 6 : firstDay - 1;

    const daysInMonth = moment(month).endOf("month").date();
    const daysInPrevMonth = moment(moment(month).subtract(1, "months"))
      .endOf("month")
      .date();

    const days = [];

    // Fill in the days from the previous month
    for (let i = firstDay - 1; i >= 0; i--) {
      days.push({ day: daysInPrevMonth - i, currentMonth: false });
    }

    // Fill in the days of the current month
    for (let i = 1; i <= daysInMonth; i++) {
      days.push({ day: i, currentMonth: true });
    }

    // Fill in the days from the next month
    const nextMonthDays = 35 - days.length;
    for (let i = 1; i <= nextMonthDays; i++) {
      days.push({ day: i, currentMonth: false });
    }

    return days;
  }, [month]);

  const handlePrevMonth = () => {
    setMonth((prev) => moment(prev).subtract(1, "months"));
  };

  const handleNextMonth = () => {
    setMonth((prev) => moment(prev).add(1, "months"));
  };

  const handleTimeChange = (newTime) => {
    setTime(newTime);
    // setShowTimePicker(false);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setShowDatePicker(false);
    setStartDate(formatDate(date));
    setEndDate(formatDate(date));
  };

  const handleMonthChange = (direction) => {
    if (direction === "prev") {
      setMonth((prev) => moment(prev).subtract(1, "months"));
    } else if (direction === "next") {
      setMonth((prev) => moment(prev).add(1, "months"));
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [showTimePicker, showTimePicker])

  
  const handleOutsideClick = (event) => {
    const Div = document.getElementById('view-dialogue');
    console.log(Div, event);

    if (!Div?.contains(event.target)) {
      setShowDatePicker(false);
      setShowDatePicker(false);
    }
  }


  return (
    <div className="calendar">
      <div className="d-flex flex-row flex-wrap justify-content-center align-items-center justify-content-sm-between">
        <div className="left-side p-sm-0 px-5 d-flex gap-3 position-relative">
          {/* Today Button */}
          <div
            className="filter-btn"
            onClick={() => {
              const today = new Date();
              setStartDate(today);
              setEndDate(today);
            }}
          >
            <span className="fw-600">Today</span>
          </div>

          {/* Time Filter */}
          <div
            className="filter-btn"
            onClick={() => setShowTimePicker(!showTimePicker)}
          >
            <FaClock size={18} />
            <span className="fs-7 mx-auto ms-1">{time} IST</span>
          </div>
          {showTimePicker && (
            <div className="time-picker-container" >
              <TimePicker
                onChange={handleTimeChange}
                value={time}
                disableClock
                clearIcon={null}
                id="view-dialogue"
              />
            </div>
          )}

          {/* Date Filter */}
          <div
            className="filter-btn"
            onClick={() => setShowDatePicker(!showDatePicker)}
          >
            <FaRegCalendarAlt size={18} />
            <span className="fs-7 mx-auto ms-1">
              {selectedDate.toLocaleDateString()}
            </span>
          </div>
          {showDatePicker && (
            <div className="date-picker-container" id="view-dialogue">
              <DatePicker
                selected={selectedDate}
                onChange={handleDateChange}
                inline
                id="view-dialogue"
              />
            </div>
          )}
        </div>

        <div className="right-side d-flex flex-row">
          {/* Month Navigation */}
          <div className="align-items-center d-flex flex-row justify-content-between text-center mx-2 gap-2">
            <div className="border py-0 rounded-2 filter-btn">
              <span
                className="left-arrow cursor-pointer fs-4"
                onClick={() => handleMonthChange("prev")}
              >
                <MdKeyboardArrowLeft />
              </span>
            </div>
            <div className="border py-0 rounded-2 filter-btn">
              <span
                className="right-arrow cursor-pointer fs-4"
                onClick={() => handleMonthChange("next")}
              >
                <MdKeyboardArrowRight />
              </span>
            </div>
            <div className="border rounded-2 filter-btn">
              <span className="w-100 fs-7 mx-auto ms-1 fw-600">
                {`${MonthNames[moment(month).month()]}`}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Calendar Days */}
      <div className="focus-in-expand mt-3">
        <div className="monthly-view">
          {/* Day Names */}
          <div className="day-names">
            {DaysName.map((day, index) => (
              <div key={index} className="day-name">
                {day}
              </div>
            ))}
          </div>

          {/* Calendar Days */}
          <div className="days">
            {days.map((day, index) => {
              // Find all events for this particular day
              const eventsForDay = data.filter(
                (event) =>
                  moment(event.appointment_date_at).date() === day.day &&
                  moment(event.appointment_date_at).month() ===
                    moment(month).month()
              );

              return (
                <div
                  key={index}
                  className={`day ${
                    !day.currentMonth ? "other-month" : "current-month"
                  } ${
                    eventsForDay.length > 0 ? "active-day cursor-pointer" : ""
                  }`}
                >
                  {day.currentMonth ? (
                    <div>
                      <span className="fw-lighter">{day.day}</span>
                      {/* Render events if any */}
                      {eventsForDay.length > 0 &&
                        eventsForDay.map((event, eventIndex) => {
                          const color1 = "#BA1717"; // Red
                          const color2 = "#33BA46"; // Green

                          const lightColor1 = "#F9F2F2"; // Lighter red shade for background
                          const lightColor2 = "#F0F9F2"; // Lighter green shade for background
                          const borderColor1 = "#FEE1E1"; // Light red shade for border
                          const borderColor2 = "#C2EECC"; // Light green shade for border

                          // Define the alternating background and border colors
                          const eventBackgroundColor =
                            eventIndex % 2 === 0 ? lightColor1 : lightColor2; // Light background
                          const eventBorderColor =
                            eventIndex % 2 === 0 ? borderColor1 : borderColor2; // Light border
                          const eventCircleColor =
                            eventIndex % 2 === 0 ? color1 : color2; // Circle color (primary colors)

                          return (
                            <div
                              key={eventIndex}
                              className="event event_show d-inline-flex align-items-center gap-1"
                              style={{
                                backgroundColor: eventBackgroundColor,
                                borderColor: eventBorderColor,
                                color: "black",
                                maxWidth: "120px",
                                padding: "8px 12px",
                                borderRadius: "12px",
                                border: "1px solid",
                              }}
                              title={
                                event.appointment_meetings[0]?.patient_name
                              }
                            >
                              <div
                                className="event_circle"
                                style={{
                                  backgroundColor: eventCircleColor,
                                  width: "10px", 
                                  height: "10px", 
                                  // marginRight: "8px", 
                                  borderRadius: "50%",
                                }}
                              ></div>
                              <span className="text-truncate w-75">
                                Meeting with{" "}
                                {event.appointment_meetings[0]?.patient_name}
                              </span>
                            </div>
                          );
                        })}
                    </div>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MonthlyCalendar;
